var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompTable',{attrs:{"title":"查阅情况统计","columns":_vm.columns,"table-api":_vm.api}})}
var staticRenderFns = []

export { render, staticRenderFns }